<template>
  <div>
    <dashboard-header :text='$t("employee.caption")'/>
    <v-card
        elevation="0"
        class="card-border-10">
      <d-table
          class="pa-10"
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :item-click="onItemTableClick"
          :edit="isEdit ? editItem : null"
          :add="isCreate ? addItem : null "
          :on-delete="isDelete ? deleteItem : null"
          :change-password="changePassword"
          :get-items="getItems"
          :custom-total-rows="totalRows"
          :placeholder="$t('employee.searchPlaceholder')"
          context="employee"
      >
        <template v-slot:filter>
          <div class="d-flex align-center mx-3">
            <div class="me-2 text-body-1 text-nowrap d-flex align-center" style="margin-bottom: 25px">{{ $t("base.filterByDepartment") }}</div>
            <v-select
                :loading="filterLoading"
                v-model="selectedFilter"
                :items="listFilter"
                :placeholder="$t('employee.selectDepartment')"
                v-on:change="customFilter"
                item-text="name"
                small-chips
                chips
                deletable-chips
                return-object
                dense
                outlined
                style="min-width: 250px">
            </v-select>
          </div>
        </template>

        <!-- Ellipsis for Department column -->
        <template v-slot:item.department="{ item }">
          <div class="ellipsis-cell" style="max-width: 220px;" :title="item.department">
            {{ item.department }}
          </div>
        </template>

        <!-- Ellipsis for Title column -->
        <template v-slot:item.title="{ item }">
          <div class="ellipsis-cell" style="max-width: 220px;" :title="item.title">
            {{ item.title }}
          </div>
        </template>
      </d-table>
    </v-card>
  </div>
</template>

<script>
import dTable from "../base/DataTable.vue";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";
import { PERMISSIONS } from "../../config/permissions";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      items: [],
      totalRows: 0,
      optionParams: null,
      // removed static permissions - moved to computed
      filterLoading: false,
      listFilter: [],
      selectedFilter: null,
    };
  },
  mounted() {
    this.onTab()
  },
  computed: {
    // Permission computed properties
    isCreate() {
      return this.hasPermission(PERMISSIONS.EMPLOYEE_CREATE);
    },
    isEdit() {
      return this.hasPermission(PERMISSIONS.EMPLOYEE_UPDATE);
    },
    isDelete() {
      return this.hasPermission(PERMISSIONS.EMPLOYEE_DELETE);
    },
    fields() {
      return [
        {value: "name", text: i18n.t("employee.name")},
        {value: "username", text: i18n.t("account.username"), sortable: false},
        {value: "email", text: i18n.t("account.email"), sortable: false},
        {value: "phoneNumber", text: i18n.t("employee.phoneNumber"), sortable: false},
        {value: "department", text: i18n.t("employee.department"), sortable: false, width: '220px'},
        {value: "title", text: i18n.t("employee.title"), sortable: false, width: '220px'},
        {value: this.isEdit || this.isDelete ? "actions" : null, sortable: false}
      ].filter(field => field.value !== null);
    },
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams);
      this.getListFilter();
    },
    async getItems(optionParams) {
      if (!optionParams) return
      optionParams.departmentId = this.selectedFilter ? this.selectedFilter.departmentId : null
      this.optionParams = optionParams
      let res = await this.get(API2.EMPLOYEE, optionParams)
      if (!res) return
      this.totalRows = res.total
      this.items = res.data.map(value => {
        return {
          data: {...value, idDetail: value.employeeId},
          name: value.name,
          username: value.username,
          email: this.shortenText(value.email, 25),
          phoneNumber: value.phoneNumber,
          title: value.titleInfo.name,
          titleId: value.titleInfo.titleId,
          department: value.departmentInfo.name,
          departmentId: value.departmentId,
        };
      });
    },
    async getListFilter() {
      let res = await this.get(API2.DEPARTMENT, null, "filterLoading")
      this.listFilter = res.data?.map(i => ({... i, name: this.shortenText(i.name, 40)}));
    },
    customFilter() {
      this.getItems(this.optionParams)
    },
    addItem() {
      this.openTab(2)
    },
    editItem(item) {
      this.openTab(2, item)
    },
    onItemTableClick(item) {
      if (!this.checkPermissionOrShowError(PERMISSIONS.EMPLOYEE_VIEW, 'Bạn không có quyền xem chi tiết nhân viên')) {
        return;
      }
      this.openTab(1, item)
    },
    onDeleteContent() {
      return i18n.t("ui.confirmDataDelEmployee")
    },
    async deleteItem(item) {
      let res = await this.delete(API2.EMPLOYEE, {path: item.data.employeeId})
      if (res) {
        this.showToast("success", i18n.t("base.notification"), i18n.t("base.deleteSuccessful"))
        this.getItems(this.optionParams);
      }
    },
    changePassword(item) {
      this.openTab(3, item)
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
  }
};
</script>

<style>
.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
